<div data-test="form-error" class="error-box" [ngClass]="{ 'error-icon': hasIcon }">
  <div class="error-message" *ngFor="let error of errorsList; trackBy: trackByError">
    <flo-svg-icon data-test="form-error-icon" *ngIf="hasIcon" class="icon flo-svg-minus-background" icon="exclamation" width="1.5rem"></flo-svg-icon>
    <p floAnalytics data-test="form-error-message" class="error-msg" >{{ error }}</p>
  </div>
</div>